import styled, { createGlobalStyle, css } from 'styled-components';

// const css = baseCss as sc.ThemedCssFunction<sc.DefaultTheme>;
// const createGlobalStyle = baseCreateGlobalStyle as typeof sc.createGlobalStyle;
// const styled = baseStyled as typeof sc.default;

export { createGlobalStyle, css };
export default styled;
